// import apiRoutes from "@/src/apiRoutes";
// import { Button } from "@/src/components/Button/Button";
import InputComponent from "@/src/components/Input/Input";
// import { textVariants } from "@/src/components/Text/Text";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/src/components/shad/card";
// import api from "@/src/utils";
import { zodResolver } from "@hookform/resolvers/zod";
// import { useMutation } from "@tanstack/react-query";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
// import { toast } from "sonner";
import { z } from "zod";

const nameState = z.object({
  first_name: z
    .string()
    .min(2, { message: "First name must be 2 or more characters" }),
  surname: z
    .string()
    .min(2, { message: "Last name should be 2 or more characters" }),
});

const Name = ({ profile }: { profile: PaintProfile | undefined }) => {
  type nameType = z.infer<typeof nameState>;

  const {
    register,
    // handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<nameType>({
    resolver: zodResolver(nameState),
  });
  // const updateName = async (data: nameType) => {
  //   const res = await api.post(apiRoutes.nameChange, data);
  //   return res.data;
  // };

  // const { mutate } = useMutation({
  //   mutationKey: ["update_name"],
  //   mutationFn: updateName,
  //   onSuccess: (data) => {
  //     if (data?.success) {
  //       toast.success(data?.info);
  //     } else {
  //       toast.warning(data?.info);
  //     }
  //   },
  // });

  // const onSubmit: SubmitHandler<nameType> = (data) => {
  //   mutate(data);
  // };

  useEffect(() => {
    if (profile) {
      setValue("first_name", profile?.first_name);
      setValue("surname", profile?.surname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);
  return (
    <Card>
      <CardHeader>
        <CardTitle>Name</CardTitle>
        <CardDescription>
          This is the name that is visible on your account.
        </CardDescription>
      </CardHeader>
      <form>
        <CardContent>
          <div className="grid  md:grid-cols-2 gap-3 pb-6">
            <InputComponent
              label="Firstname"
              type={"text"}
              readOnly
              {...register("first_name", { required: true })}
              defaultValue={profile?.first_name}
              errors={errors.first_name?.message}
            />
            <InputComponent
              label="Lastname"
              type={"text"}
              readOnly
              defaultValue={profile?.surname}
              {...register("surname", { required: true })}
              errors={errors.surname?.message}
            />
          </div>
        </CardContent>
        {/* <CardHeader className=" bg-back p-2 flex flex-row justify-between items-center border-t rounded-b-lg">
          <span className={textVariants({ variant: "desc", font: "medium" })}>
            Update name
          </span>

          <Button
            variant="primary"
            onClick={handleSubmit(onSubmit)}
            loading={isLoading}
          >
            Save
          </Button>
        </CardHeader> */}
      </form>
    </Card>
  );
};

export default Name;
